<template>
  <div id="container-table" class="overflow-auto">
    <ts-table :columnLengths="7" :records="datatable">
      <template v-slot:thead>
        <thead>
          <tr>
            <th width="5%">{{ $t('approvalRequestFlow.levelOrder') }}</th>
            <th width="15%">{{ $t('approvalRequestFlow.approverType') }}</th>
            <th width="20%">{{ $t('approvalRequestFlow.approver') }}</th>
            <th width="15%">{{ $t('approvalRequestFlow.approverTypeCc') }}</th>
            <th width="20%">{{ $t('approvalRequestFlow.approverCc') }}</th>
            <th style="width: 1px;">
              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  v-tooltip="$t('add_new')"
                  @click.prevent="addNew()"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </th>
          </tr>
          <TableProgressBar v-show="loading" :columnLength="6" />
        </thead>
      </template>
      <template v-slot="{ record }">
        <td width="15%">
          <input
            type="number"
            class="form-control"
            v-model.number="record.level_order"
          />
        </td>
        <td>
          <select
            class="form-control"
            v-model="record.approver_type_id"
            @change="onApproverTypeChange(record)"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
            <option
              v-for="(appType, index) in approverTypes"
              :key="index"
              :value="appType.approver_type_id"
              >{{ appType.approver_type }}</option
            >
          </select>
        </td>
        <td width="15%">
          <select
            v-if="record.approver_type_id == null"
            class="form-control"
            v-model="record.approver_type_value"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
          </select>
          <treeselect
            v-if="record.approver_type_id == 1"
            :options="userOptions"
            :placeholder="$t('approvalRequestFlow.user')"
            v-model="record.approver_type_value"
            :maxHeight="150"
          />
          <treeselect
            v-if="record.approver_type_id == 2"
            :options="roleOptions"
            :placeholder="$t('approvalRequestFlow.mobileRole')"
            v-model="record.approver_type_value"
            :maxHeight="150"
          />
        </td>
        <td width="15%">
          <select class="form-control" v-model="record.approver_type_cc_id">
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
            <option
              v-for="(appType, index) in approverTypes"
              :key="index"
              :value="appType.approver_type_id"
              >{{ appType.approver_type }}</option
            >
          </select>
        </td>
        <td width="30%">
          <select
            v-if="record.approver_type_cc_id == null"
            class="form-control"
            v-model="record.approver_type_value"
          >
            <option :value="null" disabled selected style="display: none;">{{
              $t('select')
            }}</option>
          </select>
          <treeselect
            v-if="record.approver_type_cc_id == 1"
            :options="userOptions"
            :placeholder="$t('approvalRequestFlow.user')"
            v-model="record.approver_type_cc_value"
            :maxHeight="150"
          />
          <treeselect
            v-if="record.approver_type_cc_id == 2"
            :options="roleOptions"
            :placeholder="$t('approvalRequestFlow.mobileRole')"
            v-model="record.approver_type_cc_value"
            :maxHeight="150"
          />
        </td>
        <td width="1px">
          <div class="ts-flex">
            <button
              type="button"
              v-tooltip="$t('delete')"
              class="btn btn-danger btn-xs"
              @click="destroy(record)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </td>
      </template>
    </ts-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'approval-flow-detail',
  components: { TableProgressBar },
  props: ['value'],
  data () {
    return {
      datatable: [],
      item: {
        id: 0,
        level_order: '',
        approver_type_id: null,
        approver_type_value: null,
        approver_type_cc_id: null,
        approver_type_cc_value: null
      },
      loading: false
    }
  },
  created () {
    this.loading = true
    Promise.all([this.fetchUser(), this.fetchMobileRole()]).then(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapState('setting/approvalRequestFlow', ['approverTypes']),
    userOptions () {
      return this.$store.state.setting.approvalRequestFlow.users.map(el => ({
        id: el.user_id,
        label: el.name
      }))
    },
    roleOptions () {
      return this.$store.state.setting.approvalRequestFlow.roles.map(el => ({
        id: el.mobile_role_id,
        label: el.role_name + ' => ' + el.description
      }))
    }
  },

  methods: {
    ...mapActions('setting/approvalRequestFlow', [
      'fetchUser',
      'fetchMobileRole'
    ]),

    onApproverTypeChange (item) {
      item.approver_type_value = null
    },

    destroy (item) {
      this.datatable.splice(this.datatable.indexOf(item), 1)
    },

    addNew () {
      this.datatable.push(_.clone(this.item))
    },
    pushToDatatable () {
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          id: data.id,
          level_order: data.level_order,
          approver_type_id: data.approver_type_id,
          approver_type_value:
            data.approver_type_value != 0 ? data.approver_type_value : null,
          approver_type_cc_id: data.approver_type_cc_id,
          approver_type_cc_value: data.approver_type_cc_value
        })
        this.$nextTick(() => {
          this.datatable.push(detail)
        })
      })
    }
  },

  watch: {
    value: {
      handler (val) {
        if (val.length <= 0) {
          this.datatable = []
        }
        if (_.isEqual(val, this.datatable)) return

        this.pushToDatatable()
      },
      deep: true,
      immediate: true
    },

    datatable: {
      handler (val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
#container-table {
  min-height: 25vh;
  max-height: 40vh;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 99;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
</style>
